import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

import blob1 from '../../assets/loaderBlob1.svg';
import blob2 from '../../assets/loaderBlob2.svg';
import blob3 from '../../assets/loaderBlob3.svg';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 115px;
`;

export const Blobs = styled.div`
  position: relative;
  width: 186px;
  height: 198px;
`;

const spin1 = keyframes`
    from {
        transform: rotate(0deg);
    };
    to {
        transform: rotate(360deg)
    }
`;

const spin2 = keyframes`
    from {
        transform: rotate(360deg);
    };
    to {
        transform: rotate(0deg)
    }
`;

const spin3 = keyframes`
    from {
        transform: rotate(0deg);
    };
    to {
        transform: rotate(360deg)
    }
`;

export const Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: center;
  &.blob1 {
    animation: ${spin1} 3s infinite linear;
    z-index: 3;
  }
  &.blob2 {
    animation: ${spin2} 5s infinite linear;
  }
  &.blob3 {
    animation: ${spin3} 6s infinite linear;
  }
`;

export const Loader = () => {
  return (
    <Container>
      <Blobs>
        <Img src={blob1} className="blob1" alt="" />
        <Img src={blob2} className="blob2" alt="" />
        <Img src={blob3} className="blob3" alt="" />
      </Blobs>
    </Container>
  );
};
